@if (filters && orderSelectConfig) {
  <sd-filters
    id="recipe-card-grid-filters"
    (selectedFilters)="onSelectedFilters($event)"
    (orderedBy)="onSortSelected($event)"
    [filters]="filters"
    [titleLevel]="4"
    [orderSelectConfig]="orderSelectConfig"
    idFilterCollapse="filterCollapseId"
  >
    @if (hasControl) {
      <sd-form-input
        sd-form-input
        [formControl]="formControl"
        type="search"
        [labelHidden]="true"
        [isFormAddon]="true"
        [placeholder]="'recipes.list.placeholder' | translate"
        (keyup.enter)="search()"
        (clear)="clearQuery()"
      />
    }
  </sd-filters>
}

<section class="c__recipe-grid-wrapper">
  <ul class="c__items">
    @for (recipe of recipes; track recipe.id) {
      <li class="c__item">
        <article>
          <sd-recipe-card
            [recipeContent]="recipe"
            (recipeClicked)="onRecipeClick(recipe)"
            [isLoading]="isLoading"
          />
        </article>
      </li>
    }
  </ul>
</section>

@if (pagination.totalPages > 1) {
  <div class="c__actions">
    <sd-pagination
      [linkUrl]="linkUrl"
      [activePage]="(pagination.number + 1)"
      [pages]="pagination.totalPages"
      (clickedPage)="onClickedPage($event)"
    />
  </div>
}
